"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutMe() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="154377" id="founderbio" className="relative w-full bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={imageRef} className={`lg:col-span-5 lg:col-start-1 relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative group overflow-hidden rounded-none border border-border">
              <AspectRatio ratio={3 / 4} className="bg-muted">
                <img src="https://dynestate.com/wp-content/uploads/2026/06/Headshot-Up-Close.jpeg" alt="Jihad Abdur-Rahman - Founder of Dynestate" className="object-cover w-full h-full grayscale contrast-150 transition-transform duration-1000 group-hover:scale-105" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent mix-blend-multiply" />
              </AspectRatio>
              
              {}
              <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-border opacity-50 m-4" />
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-border opacity-50 m-4" />
            </div>
          </div>

          {}
          <div ref={contentRef} className={`lg:col-span-6 lg:col-start-7 flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight text-foreground">
              Founder <br />
              <span className="text-muted-foreground italic">Bio</span>
            </h2>
            
            <Separator className="w-16 h-[1px] bg-border my-8" />
            
            <div className="font-sans text-sm md:text-base leading-relaxed text-muted-foreground space-y-6">
              <p className="font-bold text-foreground text-xl md:text-2xl tracking-tight">
                Jihad Abdur-Rahman
              </p>
              <p>Jihad Abdur-Rahman is the visionary behind DynEstate, bringing years of institutional expertise in capital markets and real estate structuring. His leadership is defined by a commitment to delivering sophisticated financing solutions that empower developers, operators, and growth-stage companies to scale with precision and strategic authority.</p>
              <p>Under his guidance, DynEstate has evolved into a premier capital marketplace, bridging the gap between private institutional credit and complex market needs. His strategic approach ensures every transaction is underpinned by rigorous underwriting and a deep understanding of the global financial landscape, maintaining the highest standards of trust and execution.</p>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-8">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none px-8">
                <Link to="/AboutPage">About DynEstate<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 size-4" aria-hidden="true" data-ast-id="f:/src/pages/About/sections/AboutMe.tsx|sig:r623bl" data-ast-start="4056" data-ast-end="4094"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>
              
              <div className="font-serif text-2xl md:text-3xl text-foreground/60 italic tracking-wider">DynEstate®</div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}